<app-header></app-header>
<div class="contenedor_principal">
    <div class="div-formacion-horizontal">
        <div class="div-espacio-1"></div>
        <div class="div-espacio-boton-catalogo">
            <div class="div-menu-alterno-1" [routerLink]="['/']">
                <div class="div-img-titulo-menu-alterno">
                    <div class="div-menu-alterno-p1"><img
                            src="/estadisticas-economicas/assets/img/iconos/estadisticas-graficas-interactivas.svg" class="img-boton-inicio" alt="ícono estadísticas" title="estadísticas">
                    </div>
                    <div>
                        <div><span class="texto-retornar">Retornar a</span></div>
                        <div><span class="texto-estadisticas-economicas">{{constantes.ETIQUETA_BOTON_APLICACION}}</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="div-espacio-3"></div>
        <div class="div-espacio-busqueda-catalogo">
            <div class="div-input-busqueda">
                <input #myInput type="text" id="myInput" (keyup.enter)="buscarPalabraMenu(myInput.value)"
                    class="input-text-catalogo" placeholder="Buscar"
                    title="Escriba una palabra clave"><input class="input-button-catalogo" type="image" alt="buscar" title="buscar"
                    src="/estadisticas-economicas/assets/img/iconos/search.avif" (click)="buscarPalabraMenu(myInput.value)" />
            </div>
        </div>

        <div class="div-espacio-boton-catalogo-completo">
            <div class="div-img-titulo-menu-alterno" [routerLink]="['/detalle-catalogo']">
                <div>
                    <span class="texto-visualizar">Visualizar</span><br>
                    <span class="texto-catalogo-completo">Catálogo completo</span>
                </div>
                <div class="div-menu-alterno-p1"><img src="/estadisticas-economicas/assets/img/book.avif" class="img-boton-inicio" alt="ícono libro" title="libro"></div>
            </div>
        </div>
    </div>

    <div class="contenidoDivTitulo">
        <div class="div-titulo-seccion">
            <h1 class="h1-titulo-app">Catálogo para consulta de datos - estadísticas económicas</h1>
        </div>
        <div class="div-linea-titulo"></div>
    </div>
    <!--INICIO-->
    <div>
        <div id="thumbnail-slider">
            <div class="inner" id="menu-estadisticas-slider">
                <div class="div-principal">
                    <div class="div-opcion" *ngFor="let opcion of listaTablaCatalogo">
                        <div class="div-titulo-categoria-catalogo" id="titulo-{{opcion.id}}">
                            <img class="img-titulo-opcion" src="{{opcion.imagen}}" width="60px" alt="ícono opción" title="ícono opción">
                            <h3 class="div-titulo-opcion" [innerHTML]="opcion.titulo"></h3>
                        </div>
                        <div id="divMenuOpcionColumna" class="div-opcion-columna">
                            <ul class="ul-principal ul-opcion">
                                <li class="{{enlace.estiloClase}}"
                                    *ngFor="let enlace of opcion.enlaces; let indiceEnlaces=index;">
                                    <div *ngIf="enlace.direccion_a_tabla == 'S'" (click)="showChildren(opcion)">
                                        
                                        <p><img [src]="additionalDataShowChildren[opcion.id] ? '/estadisticas-economicas/assets/img/minus.avif' : '/estadisticas-economicas/assets/img/plus.avif'" src="" width="15px" style="margin-right: 12px;" alt="ícono para desplegar más opciones" title="más opciones">{{enlace.nombre}}</p>
                                    </div>
                                    <div *ngIf="enlace.mostrarHijos == 'N' && enlace.direccion_a_tabla == 'N'"
                                        (click)='openWindow(enlace, opcion)' id="texto-{{opcion.id}}" [innerHTML]="enlace.nombre">
                                    </div>
                                    <div *ngIf="enlace.mostrarHijos == 'S' && enlace.direccion_a_tabla == 'N'"
                                        [innerHTML]="enlace.nombre"> </div>
                                    <div
                                        *ngIf="enlace.menuHijos != undefined && enlace.menuHijos.length > 0 && enlace.menuHijos[0].nombre != '' && enlace.mostrarHijos == 'S'">
                                        <ul class="ul-opcion" *ngIf="(enlace.mostrarHijos === 'S' && enlace.direccion_a_tabla === 'N') || additionalDataShowChildren[opcion.id]">
                                            <li class="{{enlaceHijo.estiloClase}}"
                                                *ngFor="let enlaceHijo of enlace.menuHijos; let indiceHijo=index;">
                                                <p *ngIf="enlaceHijo.mostrarHijos == 'N' && enlaceHijo.direccion_a_tabla == 'S'" (click)="findInDashboard(enlaceHijo)"
                                                    class="enlace-texto">
                                                    {{ enlaceHijo.nombre }}
                                                </p>
                                                <div *ngIf="enlaceHijo.mostrarHijos == 'S' && enlaceHijo.direccion_a_tabla == 'N'"
                                                    [innerHTML]="enlaceHijo.nombre"> </div>
                                                <ul class="ul-opcion">
                                                    <li class="div-li-icon-grafica-1"
                                                        *ngFor="let enlaceNieto of enlaceHijo.menuHijos">
                                                        <p *ngIf="enlaceNieto.mostrarHijos == 'N' && enlaceNieto.direccion_a_tabla == 'S'" (click)="findInDashboard(enlaceNieto)"
                                                            class="enlace-texto">
                                                            {{ enlaceNieto.nombre }}
                                                        </p>
                                                        <p *ngIf="enlaceNieto.mostrarHijos == 'S' && enlaceNieto.direccion_a_tabla == 'N'">
                                                            {{ enlaceNieto.nombre }}
                                                        </p>
                                                        <div *ngIf="enlaceNieto.mostrarHijos == 'N' && enlaceNieto.direccion_a_tabla == 'N'"
                                                            (click)='openWindow(enlaceNieto, opcion, enlaceHijo)' id="texto-{{opcion.id}}"
                                                            [innerHTML]="enlaceNieto.nombre">
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div *ngIf="enlaceHijo.mostrarHijos == 'N' && enlaceHijo.direccion_a_tabla == 'N'"
                                                    (click)='openWindow(enlaceHijo, opcion)' id="texto-{{opcion.id}}"
                                                    [innerHTML]="enlaceHijo.nombre">
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--FIN-->
    <br> <br>
</div>